var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEfficiency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#000",
    transform: "rotate(-180 20 20)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M20 37.722c-6.339 0-11.9-3.328-15.033-8.331-1.704-2.723-2.69-5.942-2.69-9.391 0-4.894 1.984-9.324 5.191-12.532 3.208-3.207 7.638-5.19 12.532-5.19s9.324 1.983 12.532 5.19c3.207 3.208 5.19 7.638 5.19 12.532s-1.983 9.324-5.19 12.532c-3.208 3.207-7.638 5.19-12.532 5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.024 31.08l-1.83-2.966h5.738v-2.68h4.9v-2.813h4.816v-2.719h4.931V17.13h4.894v-2.778h4.84v-3.755c.88.04 1.662.852 2.345 2.436.5 1.158 1.558 3.52 1.564 6.967.002.846-.32 2.304-.966 4.375-1.76 5.488-4.15 9.05-7.172 10.685-3.022 1.636-6.919 2.667-11.69 3.093-3.29-.675-5.752-1.48-7.383-2.412-1.632-.933-3.294-2.487-4.987-4.661z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.8e05be5d7d2a20e28e6b8c92cdf6d909.svg";
export { ForwardRef as ReactComponent };